import { FC } from 'react';
import { Article, Heading, Link, Slider } from '@/components';
import { BlogPostDocument, BlogPostsSliceLatestPostsPrimary } from '@/types';
import classNames from 'classnames';
import { useShowByLocationSlug } from '@/hooks';

import styles from '../blog.module.scss';

const LatestPostsVariations: FC<ILatestPostsVariations> = ({
  primary,
  latestPosts,
}) => {
  const { showContent } = useShowByLocationSlug(primary?.location_slug);

  if (!showContent) return null;

  const breakpoints = {
    640: {
      spaceBetween: 32,
    },
  };

  const {
    title,
    title_color,
    see_all_link,
    see_all_text,
    see_all_text_color,
    active_control_color,
    disable_control_color,
    post_title_color,
    post_date_color,
    image_effect,
  } = primary;

  const controlSlideBorder = see_all_text_color
    ? '1px solid transparent'
    : undefined;
  const background = see_all_text_color ? 'transparent' : 'initial';

  return (
    <>
      <Slider
        breakpoints={breakpoints}
        className={classNames(
          styles.latest_blog_posts__carousel,
          'latest_blog_post__carousel',
        )}
        seeAllElement={
          <Link
            aria-label={`Go to ${see_all_link ?? '/blog'}`}
            className={classNames(styles.products__see_all)}
            href={see_all_link ?? '/blog'}
            style={{ color: see_all_text_color!, backgroundClip: background! }}
          >
            {see_all_text ?? 'SEE ALL'}
          </Link>
        }
        showSliderButtons
        showSliderHeader
        sliderHeading={
          <Heading level={2} style={{ color: title_color! }}>
            {title}
          </Heading>
        }
        spaceBetween={16}
        style={{ background: 'inherit' }}
      >
        {latestPosts?.map(item => (
          <Article
            article={item}
            classCss={styles.latest_blog_posts__carousel_article}
            imageEffect={image_effect}
            key={item.id}
          />
        ))}
      </Slider>
      <style>
        {`.latest_blog_post__carousel {
            .slick-arrow {
              color: ${active_control_color!};
              border: ${controlSlideBorder!};

              &:hover {
                color: ${active_control_color!};
              }

              &.slick-prev {
                border: ${controlSlideBorder!};

                &::after {
                  border-right: ${controlSlideBorder!};
                }
              }

              &.slick-disabled {
                color: ${disable_control_color}
              }
            }
          }

          .article {
            h5, i {
              color: ${post_title_color};
            }
            time {
              color: ${post_date_color}; 
            }
            button:not(:last-child) {
              border-right: 1px solid ${post_title_color};
            }
          }
        `}
      </style>
    </>
  );
};

interface ILatestPostsVariations {
  primary: BlogPostsSliceLatestPostsPrimary;
  items: [];
  latestPosts: BlogPostDocument[];
}

export default LatestPostsVariations;
